export class ValidationConstants{
    minAmountOneShot: number;
    minAmountMonthly: number;
    maxAmountOneShot: number;
    maxAmountMonthly: number;
    minDuration: number;
    maxDuration: number;
}
